import PropTypes from 'prop-types';

export enum PAGINATOR_BUTTON_VIEW {
    RED = 'red',
    GREEN = 'green',
    DEFAULT = 'default',
    PALE = 'pale',
    BLUE = 'blue',
    DARK = 'dark',
    EXTRA_DARK = 'extra-dark',
    EXTRA_RED = 'extra-red',
    ORANGE = 'orange',
}

export const MIN_CAPACITY = 5;
export const DEFAULT_CAPACITY = 12;
export const CAPACITY_RESERVE = 2;
export const SCROLL_RESERVE = 1;
export const MIN_SCROLL = 0;
export const paginatorButtonViewPropType = PropTypes.oneOf(Object.values(PAGINATOR_BUTTON_VIEW));
export const paginatorPagePropType = PropTypes.shape({
    disabled: PropTypes.bool,
    number: PropTypes.number,
    text: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    view: paginatorButtonViewPropType,
});

export enum PAGINATOR_ORIENTATION {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
    HORIZONTAL_RESPONSIVE = 'horizontal_responsive',
}

export enum PAGINATOR_THEME {
    WHITE = 'white',
    DEFAULT = 'default',
    CLEAR = 'clear',
}
